import React, { useMemo, useRef, useState } from "react";
import classNames from "classnames";
import { Popover, PopoverBody, PopoverHeader } from "Components/ReactstrapSlim";
import { useClickOutside } from "Hooks";
import { ActivityMaybeMemberViewModel, IActivityMaybeMemberViewModel, IReservationMaybeMemberViewModel, IReservationMemberViewModel } from "Services/API/API";
import { AvatarCircle } from "Components/AvatarCircle";


export interface GuestAvatarListProps {
   organizer?: IReservationMemberViewModel,
   guests: IReservationMaybeMemberViewModel[] | IActivityMaybeMemberViewModel[],
   capacity: number,
   title?: string,
   displayCount?: number,
   extendOnClick?: boolean,
   extendOnHover?: boolean,
   className?: string,
   bindTarget?: Element,
   id?: string,
   onAddGuests?: () => void,
}
export const GuestAvatarList: React.FC<GuestAvatarListProps> = ({ organizer, title, guests, capacity, className, id, displayCount = 3, extendOnClick = false, extendOnHover = false, bindTarget, onAddGuests }) => {
   const [isExtendedByClick, setIsExtendedByClick] = useState(false);
   const [isExtendedByHover, setIsExtendedByHover] = useState(false);
   const popoverRef = useRef<HTMLDivElement>(null);
   const avatarsListRef = useRef<HTMLDivElement>(null);

   //BindTaget should be changed to modal from document because modals stop document clicks propagations.
   useClickOutside(popoverRef, (event: Event) => {
      setIsExtendedByClick(false);
   }, bindTarget, !extendOnClick);

   const extendList = (e: React.MouseEvent) => {
      if (extendOnClick) {
         e.stopPropagation();
         setIsExtendedByClick(true);
      }
      if (extendOnHover) {
         setIsExtendedByHover(false);
      }
   }

   const fullGuestList = useMemo(() => {
      if (organizer)
         return [organizer, ...guests];
      else
         return guests;
   }, [organizer, guests])

   return (<div ref={avatarsListRef} id={id} onClick={extendList} onMouseEnter={() => extendOnHover && setIsExtendedByHover(true)} onMouseLeave={() => extendOnHover && setIsExtendedByHover(false)} className={classNames("guest-avatar-list", { "guest-avatar-list-extendable": extendOnClick }, className)}>
      {fullGuestList.slice(0, displayCount).map((invitee, index) => <AvatarCircle key={invitee.email} colorIndex={index} noborder={index == 0} {...invitee} />)}
      {fullGuestList.length > displayCount ? <span className="guest-avatar-list-plus">{`+${fullGuestList.length - displayCount}`}</span> : null}
      {extendOnClick && <Popover fade={false} hideArrow placement={"bottom-end"} isOpen={isExtendedByClick} target={avatarsListRef} toggle={() => { setIsExtendedByClick(false); }} className={"guest-avatar-extended-list-popup"}>
         <div ref={popoverRef}>
            <PopoverBody className="guest-avatar-extended-list">
               {fullGuestList.map((guest, index) => <div key={guest.email} className="guest-avatar-extended-item">
                  <AvatarCircle className="guest-avatar-extended-item-avatar" colorIndex={index} {...guest} />
                  <div className="guest-avatar-extended-item-name text-truncate">
                     <div className="text-truncate">{guest.firstName} {guest.lastName}</div>
                     {!!organizer && organizer.email == guest.email && <div className="guest-avatar-extended-item-label">Organizer</div>}
                  </div>
               </div>)}
               {!!onAddGuests && <div className="guest-avatar-extended-add-cta">
                  {capacity > (guests.length + 1)
                     ? <a href="#" onClick={(e) => { e.preventDefault(); onAddGuests(); }}>+Add more guests</a>
                     : <a href="#" className="disabled">All guests are invited</a>}
               </div>}
            </PopoverBody>
         </div>
      </Popover>}
      {extendOnHover && <Popover popperClassName="popper-hover" innerClassName="guest-popover-hover" fade={false} hideArrow placement={"bottom-end"} isOpen={isExtendedByHover} target={avatarsListRef} className={"guest-avatar-extended-list-popup"}>
         {title && <PopoverHeader>{title}</PopoverHeader>}
         <PopoverBody className="guest-avatar-extended-list">
            {fullGuestList.map((guest, index) => <Item key={guest.email} guest={guest} index={index} />)}
         </PopoverBody>
      </Popover>}
   </div>);
}

interface ItemProps {
   index: number;
   guest: IReservationMaybeMemberViewModel | IActivityMaybeMemberViewModel;
}
const Item: React.FC<ItemProps> = ({ index, guest }) => <div key={guest.email} className="guest-avatar-extended-item">
   <AvatarCircle className="guest-avatar-extended-item-avatar" colorIndex={index} {...guest} />
   <div className="guest-avatar-extended-item-name">
      <div>{guest.fullName}</div>
      {
         guest instanceof ActivityMaybeMemberViewModel && guest.spaceName
            ? <div className="guest-avatar-extended-item-label">{guest.spaceName}</div>
            : null
      }
   </div>
</div>